import React from 'react';
import { useNavigate } from 'react-router-dom';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { getSearchParams } from '../../../utils/url';
import './BreadCrumbs.css';

const excludedCrumbs = ['/', '/explore'];

const reqParams = {
  '/explore/buildings/.*/': ['bid', 'etid', 'floorPhys', 'floorServed', 'inclChild'], // equip instance page
  '/explore/buildings/.*': ['bid'], // equip type page
  '/explore/buildings': [], // buildings page
};

const getRequiredParams = (matchUrl) => {
  let params = [];
  const patterns = Object.getOwnPropertyNames(reqParams);
  for (let i = 0; i < patterns.length; i += 1) {
    const regex = new RegExp(patterns[i]);
    if (regex.test(matchUrl)) {
      params = reqParams[patterns[i]];
      break;
    }
  }
  return params;
};

const getParamsFromUrl = (location, reqParamNames) => {
  const params = {};
  const allParamsDict = getSearchParams(location.search || '');
  const allParams = Object.getOwnPropertyNames(allParamsDict);
  for (let i = 0; i < reqParamNames.length; i += 1) {
    if (allParams.includes(reqParamNames[i])) {
      params[reqParamNames[i]] = allParamsDict[reqParamNames[i]];
    }
  }
  return params;
};

const getSearchString = (params) => {
  const search = new URLSearchParams();
  const paramNames = Object.getOwnPropertyNames(params);
  for (let i = 0; i < paramNames.length; i += 1) {
    search.append(paramNames[i], params[paramNames[i]]);
  }
  return `?${search.toString()}`;
};

const getUrl = (match, location) => {
  const reqParamNames = getRequiredParams(match.pathname);
  const params = getParamsFromUrl(location, reqParamNames);
  const searchString = getSearchString(params);
  return `${match.pathname}${searchString}`;
};

// map & render your breadcrumb components however you want.
// each `breadcrumb` has the props `key`, `location`, and `match` included!
const Breadcrumbs = () => {
  const navigate = useNavigate();
  const breadcrumbs = useBreadcrumbs();
  const crumbsToRender = breadcrumbs.filter(
    ({ breadcrumb }) => excludedCrumbs.indexOf(breadcrumb.key.toLowerCase()) === -1
  );
  return (
    <div className="BreadCrumbs-container">
      {crumbsToRender.map(({ breadcrumb, match, location }, index) => {
        if (index + 1 === crumbsToRender.length) {
          return (
            <button type="button" className="BreadCrumbs" key={breadcrumb.key}>
              {decodeURIComponent(breadcrumb.props.children)}
            </button>
          );
        }
        return (
          <span className="BreadCrumbs" key={breadcrumb.key}>
            <button
              type="button"
              key={breadcrumb.key}
              className="BreadCrumbs-link"
              onClick={() => {
                const url = getUrl(match, location);
                navigate(url);
              }}
            >
              {decodeURIComponent(breadcrumb.props.children)}
            </button>
            <span>{index < breadcrumbs.length - 1 && <i> &gt; </i>}</span>
          </span>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
